// This icon file is generated automatically.
var CutOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.94 9.12l3.27 3.47A3.96 3.96 0 0120 16.07 3.94 3.94 0 0116.05 20a3.94 3.94 0 01-2.95-6.55L10 10.13l-3.1 3.3A3.94 3.94 0 013.95 20 3.94 3.94 0 010 16.07a3.94 3.94 0 015.77-3.49l3.26-3.46-7.47-7.95A.69.69 0 011.6.19a.7.7 0 011 .03l7.4 7.88 7.4-7.88a.7.7 0 01.99-.03c.28.26.3.7.03.98l-7.47 7.95zm-6.99 9.5a2.55 2.55 0 002.56-2.55c0-1.4-1.14-2.54-2.56-2.54a2.55 2.55 0 00-2.55 2.54c0 1.4 1.14 2.54 2.55 2.54zm12.1 0a2.55 2.55 0 002.55-2.55 2.55 2.55 0 00-5.12 0c0 1.4 1.15 2.54 2.57 2.54z" } }] }, "name": "cut", "theme": "outlined" };
export default CutOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/CutOutlined.js
// module id = 2369
// module chunks = 0